import { useEffect, useState } from 'react';

import { useCreateUserFromApplyFormMutation } from '@/graphql/generated';

import { AccountState, AccountStateType } from '../../components/submit-confirmation/types';
import { useApplicationFullName } from '../../contexts';

export const useAccountState = (emailAddress, isAccountStateAvailable) => {
  const [accountState, setAccountState] = useState<AccountStateType>(undefined);
  const [hashedUserId, setHashedUserId] = useState('');
  const [createUserFromApplyFormMutation] = useCreateUserFromApplyFormMutation();
  const applicationFullName = useApplicationFullName();

  useEffect(() => {
    if (isAccountStateAvailable) {
      createUserFromApplyFormMutation({
        variables: {
          input: { signupMinireg: { email: emailAddress, ...applicationFullName, signupChannel: 'jobs_apply_form' } },
        },
        onCompleted: (data) => {
          if (data?.createUser?.__typename === 'CreateUserSuccess' && data.createUser.success?.hashedUserId) {
            setAccountState(AccountState.NO_USER);
            setHashedUserId(data.createUser.success?.hashedUserId);
          }

          if (data?.createUser?.__typename === 'CreateUserError' && data?.createUser?.error) {
            const accountState =
              data?.createUser?.error[0]?.error === 'ERROR_REGISTER_EMAIL_REG'
                ? AccountState.EXISTS
                : AccountState.ERROR;
            setAccountState(accountState);
          }
        },
        onError: () => {
          setAccountState(AccountState.ERROR);
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emailAddress, isAccountStateAvailable]);

  return { accountState, hashedUserId };
};
